"use client";

import "./Online_Mba.css";
// import {  motion } from "framer-motion";
import AdmissionProcess from "../online-mba/admissionprocess/Admission_Process";
import Banner from "../online-mba/banner/Banner";
import BuiltforYou from "../online-mba/BuiltforYou/BuiltforYou";
import Certificate from "../online-mba/certificate/Certificate";
import FacultySection from "../online-mba/FacultySection/FacultySection";
import Fees from "../online-mba/feessection/Fees_Section";
import LearnAnyTime from "../online-mba/learnanytime/LearnAnyTime";
import LearningWithoutLimits from "../online-mba/learningwithoutlimits/Learning_Without_Limits";
import PartnersSwiper from "../online-mba/PartnersSwiper/PartnersSwiper";
import PedagogySection from "../online-mba/PedagogySection/PedagogySection";
import RoleSection from "../online-mba/rolesection/RoleSection";
import StackCardSlider from "../online-mba/StackCardSlider/StackCardSlider";
import Corporate_Boardroom from "./corporate-boardrooms/Corporate_BoardRooms";
import FAQSection from "./FAQ_Section/FAQSection";
import First_Curriculum from "./FirstCurriculum/First_Curriculum";
import Future_Ready from "./future-ready/Future_Ready";
import Testimonials from "./testimonials/Testimonials";
import UrgencySection from "./urgency-section/Urgency_Section";
import Why_Online_MBA from "./WhyOnlineMBA/Why_Online_MBA";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Specialization from "./specialization/Specialization";

const Online_Mba = () => {
  // const selectedRoute = useRef();

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    let targetId = "home"; // default

    if (path.includes("learningwithoutlimits")) {
      targetId = "learningwithoutlimits";
    } else if (path.includes("admissionprocess")) {
      targetId = "admissionprocess";
    } else if (path.includes("eligibility")) {
      targetId = "eligibility";
    }

    const el = document.getElementById(targetId);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Banner />

      <Future_Ready />

      <Specialization />

      <div id="learningwithoutlimits">
        <LearningWithoutLimits />
      </div>

      <UrgencySection />
      <BuiltforYou />
      <PedagogySection />

      <div id="eligibility">
        <Fees />
      </div>

      <FacultySection />
      <Corporate_Boardroom />

      <StackCardSlider />
      <RoleSection />

      <div id="admissionprocess">
        <AdmissionProcess />
      </div>

      <PartnersSwiper />
      <First_Curriculum />
      <LearnAnyTime />

      <Why_Online_MBA />
      <Certificate />
      <Testimonials />
      <FAQSection />
    </>
  );
};

export default Online_Mba;

{
  /* <HeroSection /> */
}
{
  /* <Feature /> */
}

{
  /* <div className="container experience_section">
        <motion.h1
          className="experience_heading"
          initial={{
            opacity: 0,
            y: 100,
            filter: "blur(15px)",
          }}
          whileInView={{
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
          }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
          }}
          viewport={{
            once: false,
            amount: 0.4,
          }}
        >
          Experience an AI-native learning ecosystem where global thinkers,
          industry pioneers, and visionary leaders inspire the next generation
          of innovators.
        </motion.h1>
      </div> */
}
